var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.66666H6.66667C3.33334 1.66666 1.66667 3.33332 1.66667 6.66666V17.5C1.66667 17.9583 2.04167 18.3333 2.50001 18.3333H13.3333C16.6667 18.3333 18.3333 16.6667 18.3333 13.3333V6.66666C18.3333 3.33332 16.6667 1.66666 13.3333 1.66666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7583 6.53334L6.43334 10.8583C6.26667 11.025 6.10834 11.35 6.07501 11.5833L5.84168 13.2333C5.75834 13.8333 6.17501 14.25 6.77501 14.1667L8.42499 13.9333C8.65832 13.9 8.98335 13.7417 9.15001 13.575L13.475 9.25C14.2167 8.50834 14.575 7.64167 13.475 6.54167C12.375 5.43334 11.5083 5.78334 10.7583 6.53334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1417 7.14999C10.5083 8.45833 11.5333 9.49166 12.85 9.85833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brandIcon.cec94ae8a5436fd17847b80a9c2fff96.svg";
export { ForwardRef as ReactComponent };